import React from 'react';
import { Box, Button } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';

export default function SaveBar({ onSave, disabled = false, saving = false }) {
  return (
    <Box sx={{ mt: 0.5 }}>
      <Button variant="contained" fullWidth onClick={onSave} disabled={disabled || saving} startIcon={<SaveIcon sx={{ fontSize: 22 }} />} sx={{ bgcolor: '#00B3BD', '&:hover': { bgcolor: '#00B3BD' }, height: 60, borderRadius: 1.2, fontSize: 22, fontWeight: 700 }}>
        {saving ? 'กำลังบันทึก...' : 'บันทึกข้อมูล'}
      </Button>
    </Box>
  );
}

